<!-- 页面内容 -->

<template>
    <div class='content'>
        <el-pagination
            background
            :layout="layout"
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            @current-change="pageChange"
            @size-change="pageSizeChange"
        />
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 10
        },
        page: {
            type: Number,
            default: 1
        },
        layout:{
          type:String,
          default:"total,prev, pager, next,sizes"
        }
    },
    methods: {
        pageChange(page) {
            this.$emit('update:page', page);
            this.$emit('change');
        },
        pageSizeChange(size) {
            this.$emit('update:pageSize', size);
            this.$emit('change');
        }
    },
}
</script>

<style lang='scss' scoped>
</style>
